<script setup>
import {ref, computed, watch} from "vue";
import VueMultiselect from "vue-multiselect";

const props = defineProps(['value', 'rawValue', 'fieldData', 'actualOptions']);
const emit = defineEmits(['input']);

const editMode = ref(false);
const model = ref('');
const modelMultiSelect = ref([]);
const modelSelect = ref([]);

const isSelect = computed(() => {
    return props.fieldData.type === 'select';
});

const isMultiSelect = computed(() => {
    return props.fieldData.type === 'multiselect' || props.fieldData.type === 'users_list';
});

const textValue = computed(() => {
    if (isMultiSelect.value) {
        return modelMultiSelect.value.join(';');
    }

    if (isSelect.value) {
        return modelSelect.value;
    }

    return model.value;
});

watch(() => props.value, (value) => {
    if (isMultiSelect.value) {
        modelMultiSelect.value = props.value?.split(';').filter(item => item) || [];
    } else if (isSelect.value) {
        modelSelect.value = props.value || '';
    }
    else {
        model.value = value;
    }
}, {immediate: true});

watch([modelMultiSelect, modelSelect], () => {
    editMode.value = false
});

watch(editMode , (newVal) => {
    if (!newVal) {
        emit('input', textValue.value);
        emit('changed');
    }
});

const isInvalid = computed(() => {
    return !textValue.value && props.rawValue
});
</script>

<template>
    <div class="custom-value">
        <div v-if="editMode" v-click-outside="() => editMode = false">
            <template v-if="fieldData.type === 'multiselect' || fieldData.type === 'users_list'">
                <VueMultiselect
                    :options="actualOptions"
                    v-model="modelMultiSelect"
                    class="form-input"
                    multiple
                    select-label=""
                    deselect-label=""
                />
            </template>

            <template v-else-if="fieldData.type === 'select'">
                <VueMultiselect
                    :options="actualOptions"
                    v-model="modelSelect"
                    class="form-input"
                    select-label=""
                    deselect-label=""
                    @change="editMode = false"
                />
            </template>

            <input
                v-else
                v-focus
                type="text"
                v-model="model"
                class="form-input"
            />
        </div>

        <div v-else @click.stop="editMode = true" style="min-height: 20px">
            <span v-if="isInvalid" class="option-error">
                {{rawValue}}
            </span>

            <span v-else>
                {{textValue}}
            </span>
        </div>
    </div>
</template>

<style scoped>
    .option-error {
        color: #dc3545;
    }

    .custom-value {
        padding: 5px;
        border-radius: 5px;
    }

    .custom-value:hover {
        background-color: #f8f9fa;
        border-radius: 5px;
        cursor: pointer;
    }
</style>
